"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMESHARE_MAINTENANCE = exports.RIGHT_TO_USE = exports.OTHER = exports.PHONE = exports.VEHICLE = exports.STORAGE = exports.RENT = void 0; // Lease sub-type

exports.RENT = "rent";
exports.STORAGE = "storage";
exports.VEHICLE = "vehicle";
exports.PHONE = "phone";
exports.OTHER = "other"; // Timeshare sub-types

exports.RIGHT_TO_USE = "right_to_use";
exports.TIMESHARE_MAINTENANCE = "timeshare_maintenance";